import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
    selector: 'ui-label',
    templateUrl: './ui-label.component.html'
})
export class UILabelComponent implements AfterViewInit {
    @ViewChild('label') label: ElementRef<HTMLSpanElement>;

    @Input() helperText: string;
    @Input() margin: boolean = true;

    ngAfterViewInit(): void {
        // this.removeAnythingOtherThanText();
    }

    removeAnythingOtherThanText() {
        Array.from(this.label.nativeElement.childNodes).forEach(child => {
            if (child instanceof HTMLElement) {
                child.remove();
            }
        });
    }
}